import { render } from "./stripes.svg?vue&type=template&id=15d1839d"
const script = {}

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__